import { useFloating, autoUpdate } from '@floating-ui/react';
import type { Placement } from '../config/get-config-popper';
import { getConfigPopper } from '../config/get-config-popper';

const useModalPosition = (boxRef: Element, placement?: Placement) => {
    const {
        placement: resolvedPlacement,
        strategy,
        middleware,
    } = getConfigPopper(boxRef, placement);

    const {
        refs,
        floatingStyles,
        update,
        placement: finalPlacement,
        isPositioned,
    } = useFloating({
        placement: resolvedPlacement,
        strategy,
        middleware,
        // react-popper had eventListeners { scroll: false }; disable ancestor-scroll following.
        whileElementsMounted: (reference, floating, updatePosition) =>
            autoUpdate(reference, floating, updatePosition, {
                ancestorScroll: false,
            }),
    });

    return {
        setReferenceElement: refs.setReference,
        setPopperElement: refs.setFloating,
        floatingStyles,
        update,
        placement: finalPlacement,
        isPositioned,
    };
};

export default useModalPosition;
